import { render, staticRenderFns } from "./notification_fields.vue?vue&type=template&id=699587cb"
import script from "./notification_fields.vue?vue&type=script&lang=ts"
export * from "./notification_fields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports